'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var childrenHavePropXorChildren = {};

exports.__exports = childrenHavePropXorChildren;
